import { forwardRef, useEffect, useState } from 'react';
import { useResizeObserverRef } from '../../hooks/useResizeObserver';
import { HorizontalBreadcrumb } from './HorizontalBreadcrumb';
import { VerticalBreadcrumb } from './VerticalBreadcrumb';
import cn from './Breadcrumb.css.json';
import './Breadcrumb.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const Breadcrumb = /*#__PURE__*/forwardRef((props, ref) => {
  // Default to auto
  const orientation = props.orientation || 'AUTO';
  const ariaCurrent = props.ariaCurrent || 'page';

  // Handle switching between orientations
  const [isVertical, setIsVertical] = useState(orientation === 'VERTICAL');
  const [setBreadcrumbRef] = useResizeObserverRef(({
    target,
    contentRect
  }) => {
    if (target) {
      const vertical = orientation === 'VERTICAL' || orientation === 'AUTO' && contentRect.width <= 400;
      if (vertical !== isVertical) {
        setIsVertical(vertical);
      }
    }
  });
  const BreadCrumbImpl = isVertical ? VerticalBreadcrumb : HorizontalBreadcrumb;
  useEffect(() => {
    setIsVertical(props.orientation === 'VERTICAL');
  }, [props.orientation]);
  return /*#__PURE__*/_jsx("div", {
    className: props.className,
    style: props.style,
    ref: setBreadcrumbRef,
    children: /*#__PURE__*/_jsx("div", {
      "data-testid": props.testId,
      "data-landmark-label": props.landmarkLabel,
      className: cn.breadcrumb,
      role: props.role,
      "aria-labelledby": props.ariaLabelledBy,
      "aria-describedby": props.ariaDescribedBy,
      children: /*#__PURE__*/_jsx(BreadCrumbImpl, {
        ...props,
        onOpen: props.openCrumb,
        onPress: props.selectCrumb,
        onPressItem: props.selectCrumbValue,
        theme: props.theme,
        tokens: props.tokens,
        ref: ref,
        ariaCurrent: ariaCurrent
      })
    })
  });
});
//# sourceMappingURL=Breadcrumb.js.map